export default __webpack_public_path__ + "static/media/interior-unaccept.ee6274d8.png";